import { Observable } from 'rxjs';
import { ToastrService } from 'ngx-toastr';

import { Component, OnInit, ViewChild, Inject, ElementRef } from '@angular/core';

import { MatDialog, MatDialogRef, MAT_DIALOG_DATA } from '@angular/material/dialog';
import { FormGroup, FormControl, FormBuilder, Validators } from '@angular/forms';

import { AngularFirestore, AngularFirestoreCollection } from '@angular/fire/compat/firestore';
import { GoogleMap } from '@angular/google-maps';
import { CdkDragDrop, moveItemInArray } from "@angular/cdk/drag-drop";

import { SpinnerService } from '../../services/spinner.service';
import { ApiFacility, ApiFile, SettingFile, ApiSetFacilitiesRequest, ApiSplatsKeyDevice, ApiGetSplatsKeyDevicesRequest } from '../../api-client-module';
import { FacilityAttribute } from '../../firestore-models/facility-attribute';
import { Floor } from '../../firestore-models/floor';
import { UploadedFile } from '../../firestore-models/uploaded-file';
import { ProjectLanguage } from '../../firestore-models/project-language';

import { ConfigurationService } from '../../configuration.service';
import { ApiClientService } from '../../api-client.service';
import { AppConst } from '../../app-const';
import { MultiNameDialogComponent } from '../../common/multi-name-dialog/multi-name-dialog.component';
import { MultiDescDialogComponent } from '../../common/multi-desc-dialog/multi-desc-dialog.component';
import { MultiAddressDialogComponent } from '../../common/multi-address-dialog/multi-address-dialog.component';
// import { MultiInquiryDialogComponent } from '../../common/multi-inquiry-dialog/multi-inquiry-dialog.component';
import { MultiPolicyDialogComponent } from '../../common/multi-policy-dialog/multi-policy-dialog.component';
import { MultiCopyrightDialogComponent } from '../../common/multi-copyright-dialog/multi-copyright-dialog.component';
import { MultiFaqDialogComponent } from '../../common/multi-faq-dialog/multi-faq-dialog.component';
import { MultiTextMessageDialogComponent } from '../../common/multi-text-message-dialog/multi-text-message-dialog.component';
import { SelectFaviconFileDialogComponent } from '../../select-favicon-file-dialog/select-favicon-file-dialog.component';
// import { SelectLogoFileDialogComponent } from '../../select-logo-file-dialog/select-logo-file-dialog.component';
import { SelectUploadedFileDialogComponent } from '../../select-uploaded-file-dialog/select-uploaded-file-dialog.component';
import { MultiYoutubeDialogComponent } from '../../common/multi-youtube-dialog/multi-youtube-dialog.component';
import { MultiExternallinkDialogComponent } from '../../common/multi-externallink-dialog/multi-externallink-dialog.component';
import { SelectFloorsDialogComponent } from '../select-floors-dialog/select-floors-dialog.component';
import { TranslateService } from '@ngx-translate/core';


export interface FacilityDialogData {
  change_type: number;
  facility?: ApiFacility;
}

export interface marker {
  lat: number;
  lng: number;
  draggable: boolean;
}

@Component({
  selector: 'app-facility-dialog',
  templateUrl: './facility-dialog.component.html',
  styleUrls: ['./facility-dialog.component.css'],
  standalone: false,
})
export class FacilityDialogComponent implements OnInit {

  adminUser: boolean = false;

  display: string = 'home';
  isInit: boolean = true;

  //施設情報
  facility?: ApiFacility;
  //各施設情報に紐付くプロジェクトID
  projectId: string;

  isAdded: boolean = false;
  projectLanguages!: Array<ProjectLanguage>;

  //施設情報フォーム
  facilityFormGroup!: FormGroup;
  facilityIdControl!: FormControl;
  facilityAttributeIdControl!: FormControl;
  autoTransControl!: FormControl;
  facilityNamesControl!: FormControl;
  facilityDescsControl!: FormControl;
  facilityLatControl!: FormControl;
  facilityLngControl!: FormControl;
  mapZoomTopControl!: FormControl;
  mapZoomMapControl!: FormControl;
  addressesControl!: FormControl;
  policiesControl!: FormControl;
  copyrightsControl!: FormControl;
  faqsControl!: FormControl;
  themeColorControl!: FormControl;
  metaKeywordsControl!: FormControl;
  metaDescriptionControl!: FormControl;
  googleAnalyticsCodeControl!: FormControl;
  youtubeCodesControl!: FormControl;
  useYoutubeControl!: FormControl;
  externallinkNamesControl!: FormControl;
  externallinkUrlsControl!: FormControl;
  useExternallinkControl!: FormControl;
  purchaseTitlesControl!: FormControl;
  siteUrlControl!: FormControl;
  siteUrlStagingControl!: FormControl;
  telephoneNumberControl!: FormControl;
  mapDispTypeControl!: FormControl;
  visibleGoodControl!: FormControl;
  unVisibleBreadcrumbControl!: FormControl;
  unVisibleGuideNumberControl!: FormControl;
  unvisibleFloorNameControl!: FormControl;
  unvisibleReservationFacilityNameControl!: FormControl;
  notOverlapGuideControl!: FormControl;
  topTextAlignLeftControl!: FormControl;
  floorTextAlignLeftControl!: FormControl;
  exhibitTextAlignLeftControl!: FormControl;
  facilityFileLinkControl!: FormControl;
  menuStyleControl!: FormControl;
  languageIconTypeControl!: FormControl;
  voiceControlTypeControl!: FormControl;
  pinTapVoiceControlTypeControl!: FormControl;
  // ガイド
  useGuideControl!: FormControl;
  // 番号入力
  // unvisibleEnterNumControl!: FormControl;
  useNumberEntryControl!: FormControl;
  useEnterNumTitleControl!: FormControl;
  enterNumTitlesControl!: FormControl;
  enterNumHelpsControl!: FormControl;
  // アンケート
  // visibleEnqueteControl!: FormControl;
  useQuestionControl!: FormControl;
  visibleEnqueteThanksControl!: FormControl;
  useEnqueteThanksTitleControl!: FormControl;
  enqueteThanksTitlesControl!: FormControl;
  // ランキング
  // visibleRankingControl!: FormControl;
  useRankingControl!: FormControl;
  // 避難所
  // visibleShelterControl!: FormControl;
  useShelterControl!: FormControl;
  // 購入
  // visiblePaidContentControl!: FormControl;
  usePaidContentControl!: FormControl;
  // 全体マップ
  // visibleAllMapControl!: FormControl;
  useAllMapControl!: FormControl;
  // エントリーフォーム
  useEntryFormControl!: FormControl;

  useFunctionNotUsed = AppConst.USE_FUNCTION_NOT_USED;
  useFunctions = AppConst.USE_FUNCTIONS;


  mapDispTypes = AppConst.MAP_DISP_TYPES;
  voiceControlTypes = AppConst.VOICE_CONTROL_TYPES;
  pinTapVoiceControlTypes = AppConst.PIN_TAP_VOICE_CONTROL_TYPES;

  private facilityAttributesCollection!: AngularFirestoreCollection<FacilityAttribute>;
  facilityAttributes!: Observable<FacilityAttribute[]>;

  faviconFile!: UploadedFile;
  logoFiles: SettingFile[] = [];
  facilityFiles: SettingFile[] = [];
  floors: Floor[] = [];
  splatsApiTypes = [
    {key: 0, value: ''},
    {key: AppConst.SPLATS_API_TYPE_SHARE, value: '共用環境'},
    {key: AppConst.SPLATS_API_TYPE_PRODUCTION, value: '本番環境'},
  ];
  shareKeyDevices: ApiSplatsKeyDevice[] = [];
  productionKeyDevices: ApiSplatsKeyDevice[] = [];

  //GoogleMap表示
  zoom = AppConst.ZOOM_INITIAL_VALUE;
  center!: google.maps.LatLngLiteral;
  options: google.maps.MapOptions = {
    disableDefaultUI: true
  };
  currentPosition!: google.maps.LatLngLiteral
  currentPositionMarkerOption: google.maps.MarkerOptions = {
    draggable: true
  };

  uploadedFilesCollectionName = AppConst.FIRESTORE_UPLOADED_FILES;
  hallsCollectionName = AppConst.FIRESTORE_HALLS;

  @ViewChild(GoogleMap, { static: false }) map!: GoogleMap;
  @ViewChild("mapSearchField") searchField!: ElementRef;
  @ViewChild("mapSearchFieldExecute") searchFieldExecute!: ElementRef;
  private searchFieldClear!: ElementRef;
  // @ViewChild("mapSearchFieldClear") searchFieldClear!: ElementRef;
  @ViewChild("mapSearchFieldClear", { static: false }) set contentMapSearchFieldClear(contentMapSearchFieldClear: ElementRef) {
    if(contentMapSearchFieldClear) { 
      this.searchFieldClear = contentMapSearchFieldClear;
      if (!this.isInit) {
        this.searchBox = new google.maps.places.SearchBox(
          this.searchField.nativeElement
        );
        this.map.controls[google.maps.ControlPosition.TOP_CENTER].push(
          this.searchField.nativeElement
        );
        this.map.controls[google.maps.ControlPosition.TOP_CENTER].push(
          this.searchFieldExecute.nativeElement
        );
        this.map.controls[google.maps.ControlPosition.TOP_CENTER].push(
          this.searchFieldClear.nativeElement
        );
      }
    }
  }
  searchBox!: google.maps.places.SearchBox;

  currentLang: string = 'ja';
  projectBaseLang: string = 'ja';


  constructor(
    public dialogRef: MatDialogRef<FacilityDialogComponent>,
    @Inject(MAT_DIALOG_DATA) public data: FacilityDialogData,
    public dialog: MatDialog,
    private formBuilder: FormBuilder,
    private angularFirestore: AngularFirestore,
    private configurationService: ConfigurationService,
    private apiClientService: ApiClientService,
    private translate: TranslateService,
    private spinnerService: SpinnerService,
    private toastr: ToastrService,
  ) {
    this.projectId = this.configurationService.getProjectId();
    if (this.configurationService.getUserType() == AppConst.MANAGE_USER_TYPE_ADMIN) {
      this.adminUser = true;
    }
  }

  ngOnInit(): void {
    this.projectLanguages = this.configurationService.getProject().languages!;
    this.facilityAttributesCollection = this.angularFirestore.collection<FacilityAttribute>(
      AppConst.FIRESTORE_FACILITY_ATTR, ref => ref.where('project_id', '==', this.projectId));
    this.facilityAttributes = this.facilityAttributesCollection.valueChanges({ idField: 'id' });
    this.currentLang = this.translate.currentLang;
    this.projectBaseLang = this.configurationService.getProject().project_base_lang;
    this.facility = this.data.facility;
    if (!this.facility) {
      this.facility = {
        facility_id: '',
        facility_attribute_id: '',
        facility_names: [],
        facility_descs: null as any,
        floor_ids: [],
        favicon_file: '',
        logo_files: [],
        facility_files: [],
        facility_file_link: true,
        youtube_codes: [],
        use_youtube: false,
        externallink_names: [],
        externallink_urls: [],
        use_externallink: false,
        purchase_titles: [],
        latitude: this.configurationService.getProject().project_geopoint && this.configurationService.getProject().project_geopoint.latitude ? this.configurationService.getProject().project_geopoint.latitude : AppConst.LATITUDE_INITIAL_VALUE,
        longitude: this.configurationService.getProject().project_geopoint && this.configurationService.getProject().project_geopoint.longitude ? this.configurationService.getProject().project_geopoint.longitude : AppConst.LONGITUDE_INITIAL_VALUE,
        map_zoom_top: 16,
        map_zoom_map: 18,
        addresses: [],
        inquiries: [],
        policies: [],
        copyrights: [],
        faqs: [],
        theme_color: AppConst.DEFAULT_THEME_COLOR,
        meta_keywords: '',
        meta_description: '',
        google_analytics_code: '',
        site_url: '',
        site_url_staging: '',
        telephone_number: '',
        map_disp_type: AppConst.MAP_DISP_TYPE_MAP,
        visible_good: false,
        unvisible_breadcrumb: false,
        unvisible_guide_number: false,
        unvisible_floor_name: false,
        unvisible_reservation_facility_name: false,
        use_guide: AppConst.USE_FUNCTION_PC_SP,
        unvisible_enter_num: undefined,
        use_number_entry: AppConst.USE_FUNCTION_PC_SP,
        use_enter_num_title: false,
        enter_num_titles: [],
        enter_num_helps: [],
        visible_enquete: undefined,
        use_question: AppConst.USE_FUNCTION_NOT_USED,
        visible_enquete_thanks: false,
        use_enquete_thanks_title: false,
        enquete_thanks_titles: null as any,
        visible_ranking: undefined,
        use_ranking: AppConst.USE_FUNCTION_NOT_USED,
        visible_shelter: undefined,
        use_shelter: AppConst.USE_FUNCTION_NOT_USED,
        visible_paid_content: undefined,
        use_paid_content: AppConst.USE_FUNCTION_NOT_USED,
        visible_all_map: undefined,
        use_all_map: AppConst.USE_FUNCTION_NOT_USED,
        use_entry_form: AppConst.USE_FUNCTION_NOT_USED,
        not_overlap_guide: false,
        top_text_align_left: false,
        floor_text_align_left: false,
        exhibit_text_align_left: false,
        menu_style: false,
        language_icon_type: 'globe',
        voice_control_type: AppConst.VOICE_CONTROL_TYPE_OFF,
        pin_tap_voice_control_type: AppConst.PIN_TAP_VOICE_CONTROL_TYPE_OFF,
        splats_key_devices: [],
        project_id: '',
        enabled: true,
      };
      this.isAdded = true;
    }
    this.currentPosition = {
      lat: this.facility.latitude!,
      lng: this.facility.longitude!
    }
    this.center = this.currentPosition;

    this.createForm();
    this.facilityIdControl = this.facilityFormGroup.get('facilityId') as FormControl;
    this.facilityAttributeIdControl = this.facilityFormGroup.get('facilityAttributeId') as FormControl;
    this.autoTransControl = this.facilityFormGroup.get('autoTrans') as FormControl;
    this.facilityNamesControl = this.facilityFormGroup.get('facilityNames') as FormControl;
    this.facilityDescsControl = this.facilityFormGroup.get('facilityDescs') as FormControl;
    this.facilityLatControl = this.facilityFormGroup.get('facilityLat') as FormControl;
    this.facilityLngControl = this.facilityFormGroup.get('facilityLng') as FormControl;
    this.mapZoomTopControl = this.facilityFormGroup.get('mapZoomTop') as FormControl;
    this.mapZoomMapControl = this.facilityFormGroup.get('mapZoomMap') as FormControl;
    this.addressesControl = this.facilityFormGroup.get('addresses') as FormControl;
    this.policiesControl = this.facilityFormGroup.get('policies') as FormControl;
    this.copyrightsControl = this.facilityFormGroup.get('copyrights') as FormControl;
    this.faqsControl = this.facilityFormGroup.get('faqs') as FormControl;
    this.themeColorControl = this.facilityFormGroup.get('themeColor') as FormControl;
    this.metaKeywordsControl = this.facilityFormGroup.get('metaKeywords') as FormControl;
    this.metaDescriptionControl = this.facilityFormGroup.get('metaDescription') as FormControl;
    this.googleAnalyticsCodeControl = this.facilityFormGroup.get('googleAnalyticsCode') as FormControl;
    this.youtubeCodesControl = this.facilityFormGroup.get('youtubeCodes') as FormControl;
    this.useYoutubeControl = this.facilityFormGroup.get('useYoutube') as FormControl;
    this.externallinkNamesControl = this.facilityFormGroup.get('externallinkNames') as FormControl;
    this.externallinkUrlsControl = this.facilityFormGroup.get('externallinkUrls') as FormControl;
    this.useExternallinkControl = this.facilityFormGroup.get('useExternallink') as FormControl;
    this.purchaseTitlesControl = this.facilityFormGroup.get('purchaseTitles') as FormControl;
    this.siteUrlControl = this.facilityFormGroup.get('siteUrl') as FormControl;
    this.siteUrlStagingControl = this.facilityFormGroup.get('siteUrlStaging') as FormControl;
    this.telephoneNumberControl = this.facilityFormGroup.get('telephoneNumber') as FormControl;
    this.mapDispTypeControl = this.facilityFormGroup.get('mapDispType') as FormControl;
    this.visibleGoodControl = this.facilityFormGroup.get('visibleGood') as FormControl;
    this.unVisibleBreadcrumbControl = this.facilityFormGroup.get('unVisibleBreadcrumb') as FormControl;
    this.unVisibleGuideNumberControl = this.facilityFormGroup.get('unVisibleGuideNumber') as FormControl;
    this.unvisibleFloorNameControl = this.facilityFormGroup.get('unvisibleFloorName') as FormControl;
    this.unvisibleReservationFacilityNameControl = this.facilityFormGroup.get('unvisibleReservationFacilityName') as FormControl;
    this.useGuideControl = this.facilityFormGroup.get('useGuide') as FormControl;
    // this.unvisibleEnterNumControl = this.facilityFormGroup.get('unvisibleEnterNum') as FormControl;
    this.useNumberEntryControl = this.facilityFormGroup.get('useNumberEntry') as FormControl;
    this.useEnterNumTitleControl = this.facilityFormGroup.get('useEnterNumTitle') as FormControl;
    this.enterNumTitlesControl = this.facilityFormGroup.get('enterNumTitles') as FormControl;
    this.enterNumHelpsControl = this.facilityFormGroup.get('enterNumHelps') as FormControl;
    // this.visibleEnqueteControl = this.facilityFormGroup.get('visibleEnquete') as FormControl;
    this.useQuestionControl = this.facilityFormGroup.get('useQuestion') as FormControl;
    this.visibleEnqueteThanksControl = this.facilityFormGroup.get('visibleEnqueteThanks') as FormControl;
    this.useEnqueteThanksTitleControl = this.facilityFormGroup.get('useEnqueteThanksTitle') as FormControl;
    this.enqueteThanksTitlesControl = this.facilityFormGroup.get('enqueteThanksTitles') as FormControl;
    // this.visibleRankingControl = this.facilityFormGroup.get('visibleRanking') as FormControl;
    this.useRankingControl = this.facilityFormGroup.get('useRanking') as FormControl;
    // this.visibleShelterControl = this.facilityFormGroup.get('visibleShelter') as FormControl;
    this.useShelterControl = this.facilityFormGroup.get('useShelter') as FormControl;
    // this.visiblePaidContentControl = this.facilityFormGroup.get('visiblePaidContent') as FormControl;
    this.usePaidContentControl = this.facilityFormGroup.get('usePaidContent') as FormControl;
    // this.visibleAllMapControl = this.facilityFormGroup.get('visibleAllMap') as FormControl;
    this.useAllMapControl = this.facilityFormGroup.get('useAllMap') as FormControl;
    this.useEntryFormControl = this.facilityFormGroup.get('useEntryForm') as FormControl;
    this.notOverlapGuideControl = this.facilityFormGroup.get('notOverlapGuide') as FormControl;
    this.topTextAlignLeftControl = this.facilityFormGroup.get('topTextAlignLeft') as FormControl;
    this.floorTextAlignLeftControl = this.facilityFormGroup.get('floorTextAlignLeft') as FormControl;
    this.exhibitTextAlignLeftControl = this.facilityFormGroup.get('exhibitTextAlignLeft') as FormControl;
    this.facilityFileLinkControl = this.facilityFormGroup.get('facilityFileLink') as FormControl;
    this.menuStyleControl = this.facilityFormGroup.get('menuStyle') as FormControl;
    this.languageIconTypeControl = this.facilityFormGroup.get('languageIconType') as FormControl;
    this.voiceControlTypeControl = this.facilityFormGroup.get('voiceControlType') as FormControl;
    this.pinTapVoiceControlTypeControl = this.facilityFormGroup.get('pinTapVoiceControlType') as FormControl;

    this.getFaviconFile();
    this.getLogoFiles();
    this.getFiles();
    this.getFloors();

    const request: ApiGetSplatsKeyDevicesRequest = {
      access_token: '',
      change_type: 0,
      project_id: this.projectId,
    };
    this.apiClientService.getSplatsKeyDevices(request).then(
      response => {
        if (response!.ret === AppConst.API_RET_SUCCESS) {
          this.shareKeyDevices = response!.share_key_devices!;
          this.productionKeyDevices = response!.production_key_devices!;
        }
      }
    ).catch(
      error => {
        console.log(error);
      }
    );
  }

  ngAfterViewInit(): void {
    // 住所検索用
    this.searchBox = new google.maps.places.SearchBox(
      this.searchField.nativeElement
    );
    this.map.controls[google.maps.ControlPosition.TOP_CENTER].push(
      this.searchField.nativeElement
    );
    this.map.controls[google.maps.ControlPosition.TOP_CENTER].push(
      this.searchFieldExecute.nativeElement
    );
    this.map.controls[google.maps.ControlPosition.TOP_CENTER].push(
      this.searchFieldClear.nativeElement
    );
  }

  // 表示切り替え
  onDisplay(display: string) {
    this.display = display;
    // google map(ViewChild)に関して、初回ダイアログ起動時はngAfterViewInit()を通過することで設定できるが、
    // タブ切り替え操作によるページ切り替え(*ngIf処理)でhtmlの要素が消去されるとViewChildも消去される。
    // タブ切り替え操作による遷移ではngAfterViewInit()が実行されないため、ViewChild生成のタイミングで設定する。
    this.isInit = false;
  }

  //GoogleMap上のピンとフォームの値を一致させる
  onMerkerDragEnd(event: any) {
    this.facilityLatControl.setValue(this.round(event.latLng!.lat(), 8));
    this.facilityLngControl.setValue(this.round(event.latLng!.lng(), 8));
  }

  //ピンの位置
  private round(value: number, digits: number): number {
    let pow: number = 1;
    if (digits > 0) {
      pow = Math.pow(10, digits);
    }
    return Math.round(value * pow) / pow;
  }

  //Googleマップと緯度のフォーム連携
  onBlurMarkerLat() {
    if (!!this.facilityLatControl.valid) {
      this.facilityLatControl.setValue(this.round(this.facilityLatControl.value, 8));
      this.currentPosition = {
        lat: this.round(this.facilityLatControl.value, 8),
        lng: this.currentPosition.lng
      }
      this.map.panTo(this.currentPosition);
    }
  }

  //Googleマップと経度のフォーム連携
  onBlurMarkerLng() {
    if (!!this.facilityLngControl.valid) {
      this.facilityLngControl.setValue(this.round(this.facilityLngControl.value, 8));
      this.currentPosition = {
        lat: this.currentPosition.lat,
        lng: this.round(this.facilityLngControl.value, 8)
      }
      this.map.panTo(this.currentPosition);
    }
  }

  //ロゴ画像情報並べ替え
  onDropLogoFile(event: CdkDragDrop<string[]>) {
    moveItemInArray(this.logoFiles, event.previousIndex, event.currentIndex);
    let files: Array<ApiFile> = [];
    for (const file of this.logoFiles) {
      files.push({ file_id: file.id, lang_code: file.lang_code });
    }
    this.facility!.logo_files = files;
  }

  //施設画像情報並べ替え
  onDropFile(event: CdkDragDrop<string[]>) {
    moveItemInArray(this.facilityFiles, event.previousIndex, event.currentIndex);
    let files: Array<ApiFile> = [];
    for (const file of this.facilityFiles) {
      files.push({ file_id: file.id, lang_code: file.lang_code });
    }
    this.facility!.facility_files = files;
  }

  //フロア情報並べ替え
  onDropFloor(event: CdkDragDrop<string[]>) {
    moveItemInArray(this.floors, event.previousIndex, event.currentIndex);
    let floorLists: Array<string> = [];
    for (const floor of this.floors) {
      floorLists.push(floor.id!);
    }
    this.facility!.floor_ids = floorLists;
  }

  //以下、フォームの記入エラー表示
  public getErrorMessageToFacilityId() {
    return this.facilityIdControl.hasError('required')
      ? this.translate.instant('必須項目')
      : this.facilityIdControl.hasError('pattern')
          ? this.translate.instant('dialog.ALPHANUMERIC_SYMBOLS_ONLY')
          : '';
  }

  public getErrorMessageToFacilityNames() {
    return this.facilityNamesControl.hasError('required')
      ? this.translate.instant('必須項目')
      : '';
  }

  public getErrorMessageToFacilityDescs() {
    return this.facilityDescsControl.hasError('required')
      ? this.translate.instant('必須項目')
      : '';
  }

  public getErrorMessageToFacilityLat() {
    return this.facilityLatControl.hasError('required')
      ? this.translate.instant('必須項目')
      : this.facilityLatControl.hasError('pattern') || this.facilityLatControl.hasError('min') || this.facilityLatControl.hasError('max')
          ? this.translate.instant('-90から90の間で小数第８位まで')
          : '';
  }

  public getErrorMessageToFacilityLng() {
    return this.facilityLngControl.hasError('required')
      ? this.translate.instant('必須項目')
      : this.facilityLngControl.hasError('pattern') || this.facilityLngControl.hasError('min') || this.facilityLngControl.hasError('max')
          ? this.translate.instant('-180から180の間で小数第８位まで')
          : '';
  }

  public getErrorMessageToMapZoomTop() {
    return this.mapZoomTopControl.hasError('required')
      ? this.translate.instant('必須項目')
      : this.mapZoomTopControl.hasError('pattern')
          ? this.translate.instant('数値以外')
          : '';
  }

  public getErrorMessageToMapZoomMap() {
    return this.mapZoomMapControl.hasError('required')
      ? this.translate.instant('必須項目')
      : this.mapZoomMapControl.hasError('pattern')
          ? this.translate.instant('数値以外')
          : '';
  }

  public getErrorMessageToMapDispType() {
    return this.mapDispTypeControl.hasError('required')
      ? this.translate.instant('必須項目')
      : '';
  }

  public getErrorMessageToUseGuide() {
    return this.useGuideControl.hasError('required')
      ? this.translate.instant('必須項目')
      : '';
  }

  public getErrorMessageToUseNumberEntry() {
    return this.useNumberEntryControl.hasError('required')
      ? this.translate.instant('必須項目')
      : '';
  }

  public getErrorMessageToUseQuestion() {
    return this.useQuestionControl.hasError('required')
      ? this.translate.instant('必須項目')
      : '';
  }

  public getErrorMessageToUseRanking() {
    return this.useRankingControl.hasError('required')
      ? this.translate.instant('必須項目')
      : '';
  }

  public getErrorMessageToUseShelter() {
    return this.useShelterControl.hasError('required')
      ? this.translate.instant('必須項目')
      : '';
  }

  public getErrorMessageToUsePaidContent() {
    return this.usePaidContentControl.hasError('required')
      ? this.translate.instant('必須項目')
      : '';
  }

  public getErrorMessageToUseAllMap() {
    return this.useAllMapControl.hasError('required')
      ? this.translate.instant('必須項目')
      : '';
  }

  public getErrorMessageToUseEntryForm() {
    return this.useEntryFormControl.hasError('required')
      ? this.translate.instant('必須項目')
      : '';
  }

  public getErrorMessageToLanguageIconType() {
    return this.languageIconTypeControl.hasError('required')
    ? '必須項目'
    : '';
  }

  public getErrorMessageToVoiceControlType() {
    return this.voiceControlTypeControl.hasError('required')
    ? '必須項目'
    : '';
  }

  public getErrorMessageToPinTapVoiceControlType() {
    return this.pinTapVoiceControlTypeControl.hasError('required')
    ? '必須項目'
    : '';
  }

  //フォームの値を各要素に代入
  private createForm() {
    this.facilityFormGroup = this.formBuilder.group(
      {
        facilityId: [this.facility!.facility_id, [Validators.required, Validators.pattern('^[a-zA-Z0-9!-/:-@¥[-`{-~]*$')]],
        facilityAttributeId: [this.facility!.facility_attribute_id],
        facilityNames: [this.facility!.facility_names, [Validators.required]],
        facilityDescs: [this.facility!.facility_descs, [Validators.required]],
        facilityLat: [this.facility!.latitude, [Validators.required, Validators.min(-90), Validators.max(90), Validators.pattern('^(\-)?([1-9][0-9]{0,1}|0)(\.[0-9]{1,8})?$')]],
        facilityLng: [this.facility!.longitude, [Validators.required, Validators.min(-180), Validators.max(180), Validators.pattern('^(\-)?([1-9][0-9]{0,2}|0)(\.[0-9]{1,8})?$')]],
        mapZoomTop: [this.facility!.map_zoom_top, [Validators.required, Validators.pattern('^[0-9]*$')]],
        mapZoomMap: [this.facility!.map_zoom_map, [Validators.required, Validators.pattern('^[0-9]*$')]],
        addresses: [this.facility!.addresses],
        inquiries: [this.facility!.inquiries],
        policies: [this.facility!.policies],
        copyrights: [this.facility!.copyrights],
        faqs: [this.facility!.faqs],
        themeColor: [this.facility!.theme_color, [Validators.required]],
        metaKeywords: [this.facility!.meta_keywords],
        metaDescription: [this.facility!.meta_description],
        googleAnalyticsCode: [this.facility!.google_analytics_code],
        siteUrl: [this.facility!.site_url],
        siteUrlStaging: [this.facility!.site_url_staging],
        telephoneNumber: [this.facility!.telephone_number],
        youtubeCodes: [this.facility!.youtube_codes, []],
        useYoutube: [this.facility!.use_youtube, []],
        externallinkNames: [this.facility!.externallink_names, []],
        externallinkUrls: [this.facility!.externallink_urls, []],
        useExternallink: [this.facility!.use_externallink, []],
        purchaseTitles: [this.facility!.purchase_titles, []],
        mapDispType: [this.facility!.map_disp_type ? this.facility!.map_disp_type : AppConst.MAP_DISP_TYPE_SATELLITE, [Validators.required]],
        visibleGood: [this.facility!.visible_good, []],
        unVisibleBreadcrumb: [this.facility!.unvisible_breadcrumb, []],
        unVisibleGuideNumber: [this.facility!.unvisible_guide_number, []],
        unvisibleFloorName: [this.facility!.unvisible_floor_name, []],
        unvisibleReservationFacilityName: [this.facility!.unvisible_reservation_facility_name, []],
        useGuide: [
          this.facility!.use_guide ? this.facility!.use_guide : AppConst.USE_FUNCTION_PC_SP, [Validators.required]
        ],
        // unvisibleEnterNum: [this.facility!.unvisible_enter_num, []],
        useNumberEntry: [
          this.facility!.use_number_entry ? this.facility!.use_number_entry : this.facility!.unvisible_enter_num ? AppConst.USE_FUNCTION_NOT_USED : AppConst.USE_FUNCTION_PC_SP, [Validators.required]
        ],
        useEnterNumTitle: [this.facility!.use_enter_num_title, []],
        enterNumTitles: [this.facility!.enter_num_titles, []],
        enterNumHelps: [this.facility!.enter_num_helps, []],
        // visibleEnquete: [this.facility!.visible_enquete, []],
        useQuestion: [
          this.facility!.use_question ? this.facility!.use_question : this.facility!.visible_enquete ? AppConst.USE_FUNCTION_PC_SP : AppConst.USE_FUNCTION_NOT_USED, [Validators.required]
        ],
        visibleEnqueteThanks: [this.facility!.visible_enquete_thanks, []],
        useEnqueteThanksTitle: [this.facility!.use_enquete_thanks_title, []],
        enqueteThanksTitles: [this.facility!.enquete_thanks_titles, []],
        // visibleRanking: [this.facility!.visible_ranking, []],
        useRanking: [
          this.facility!.use_ranking ? this.facility!.use_ranking : this.facility!.visible_ranking ? AppConst.USE_FUNCTION_PC_SP : AppConst.USE_FUNCTION_NOT_USED, [Validators.required]
        ],
        // visibleShelter: [this.facility!.visible_shelter, []],
        useShelter: [
          this.facility!.use_shelter ? this.facility!.use_shelter : this.facility!.visible_shelter ? AppConst.USE_FUNCTION_PC_SP : AppConst.USE_FUNCTION_NOT_USED, [Validators.required]
        ],
        // visiblePaidContent: [this.facility!.visible_paid_content, []],
        usePaidContent: [
          this.facility!.use_paid_content ? this.facility!.use_paid_content : this.facility!.visible_paid_content ? AppConst.USE_FUNCTION_PC_SP : AppConst.USE_FUNCTION_NOT_USED, [Validators.required]
        ],
        // visibleAllMap: [this.facility!.visible_all_map, []],
        useAllMap: [
          this.facility!.use_all_map ? this.facility!.use_all_map : this.facility!.visible_all_map ? AppConst.USE_FUNCTION_PC_SP : AppConst.USE_FUNCTION_NOT_USED, [Validators.required]
        ],
        useEntryForm: [
          this.facility!.use_entry_form ? this.facility!.use_entry_form : AppConst.USE_FUNCTION_PC_SP, [Validators.required]
        ],
        notOverlapGuide: [this.facility!.not_overlap_guide, []],
        topTextAlignLeft: [this.facility!.top_text_align_left, []],
        floorTextAlignLeft: [this.facility!.floor_text_align_left, []],
        exhibitTextAlignLeft: [this.facility!.exhibit_text_align_left, []],
        facilityFileLink: [this.facility!.facility_file_link, []],
        menuStyle: [this.facility!.menu_style, []],
        languageIconType: [this.facility!.language_icon_type ? this.facility!.language_icon_type : 'globe', [Validators.required]],
        voiceControlType: [this.facility!.voice_control_type ? this.facility!.voice_control_type : AppConst.VOICE_CONTROL_TYPE_OFF, [Validators.required]],
        pinTapVoiceControlType: [this.facility!.pin_tap_voice_control_type ? this.facility!.pin_tap_voice_control_type : AppConst.PIN_TAP_VOICE_CONTROL_TYPE_OFF, [Validators.required]],
      }
    );
  }

  //faviconファイル設定
  private getFaviconFile() {
    if (!!this.facility!.favicon_file) {
      this.angularFirestore.doc<UploadedFile>(`${AppConst.FIRESTORE_UPLOADED_FILES}/${this.facility!.favicon_file}`).valueChanges().subscribe(doc => {
        if (!!doc) {
          this.faviconFile = doc;
        }
      });
    } else {
      this.faviconFile = null as any;
    }
  }

  //ロゴ画像ファイル設定
  private getLogoFiles() {
    this.logoFiles = [];
    if (!!this.facility!.logo_files && this.facility!.logo_files.length > 0) {
      // NOTE: in で取得できるのは最大10までのため、該当プロジェクトのアップロードファイルを全て取得してから
      //       施設情報に登録されている id で絞り込む。
      this.angularFirestore.collection<UploadedFile>(
        AppConst.FIRESTORE_UPLOADED_FILES, ref => ref.where('project_id', '==', this.projectId)
      ).valueChanges({ idField: 'id' }).subscribe(docs => {
        this.logoFiles = [];
        if (!!docs) {
          for (const logoFile of this.facility!.logo_files!) {
            for (const uploadedFile of docs) {
              if (logoFile.file_id === uploadedFile.id) {
                const settingFile: SettingFile = {
                  id: uploadedFile.id,
                  file_name: uploadedFile.file_name,
                  download_url: uploadedFile.download_url,
                  lang_code: logoFile.lang_code,
                }
                this.logoFiles.push(settingFile);
                break;
              }
            }
          }
        }
      });
    }
  }

  //施設画像ファイル設定
  private getFiles() {
    this.facilityFiles = [];
    if (!!this.facility!.facility_files && this.facility!.facility_files.length > 0) {
      // NOTE: in で取得できるのは最大10までのため、該当プロジェクトのアップロードファイルを全て取得してから
      //       施設情報に登録されている id で絞り込む。
      this.angularFirestore.collection<UploadedFile>(
        AppConst.FIRESTORE_UPLOADED_FILES, ref => ref.where('project_id', '==', this.projectId)
      ).valueChanges({ idField: 'id' }).subscribe(docs => {
        this.facilityFiles = [];
        if (!!docs) {
          for (const facilityFile of this.facility!.facility_files!) {
            for (const uploadedFile of docs) {
              if (facilityFile.file_id === uploadedFile.id) {
                const settingFile: SettingFile = {
                  id: uploadedFile.id,
                  file_name: uploadedFile.file_name,
                  download_url: uploadedFile.download_url,
                  lang_code: facilityFile.lang_code,
                }
                this.facilityFiles.push(settingFile);
                break;
              }
            }
          }
        }
      });
    }
  }

  // 変更された言語を登録
  changeLogoFileLang(i: number, event: any) {
    this.facility!.logo_files![i].lang_code = event.value;
    this.logoFiles![i].lang_code = event.value;
  }

  // 変更された言語を登録
  changeFacilityFileLang(i: number, event: any) {
    this.facility!.facility_files![i].lang_code = event.value;
    this.facilityFiles![i].lang_code = event.value;
  }

  //施設に紐付くフロア情報設定
  private getFloors() {
    this.floors = [];
    if (!!this.facility!.floor_ids && this.facility!.floor_ids.length > 0) {
      // NOTE: in で取得できるのは最大10までのため、該当プロジェクトの展示情報を全て取得してから
      //       施設情報に登録されている id で絞り込む。
      this.angularFirestore.collection<Floor>(
        AppConst.FIRESTORE_FLOORS, ref => ref.where('project_id', '==', this.projectId)
      ).valueChanges({ idField: 'id' }).subscribe(docs => {
        this.floors = [];
        if (!!docs) {
          for (const floorId of this.facility!.floor_ids!) {
            for (const floor of docs) {
              if (floorId === floor.id) {
                this.floors.push(floor);
                break;
              }
            }
          }
        }
      });
    }
  }

  //更新ボタン
  addFacility(): void {
    if (this.facilityFormGroup.valid) {
      this.facility!.facility_id = this.facilityIdControl.value;
      this.facility!.facility_attribute_id = this.facilityAttributeIdControl.value;
      this.facility!.facility_names = this.facilityNamesControl.value;
      this.facility!.facility_descs = this.facilityDescsControl.value;
      this.facility!.youtube_codes = this.youtubeCodesControl.value;
      this.facility!.use_youtube = this.useYoutubeControl.value;
      this.facility!.externallink_names = this.externallinkNamesControl.value;
      this.facility!.externallink_urls = this.externallinkUrlsControl.value;
      this.facility!.use_externallink = this.useExternallinkControl.value;
      this.facility!.purchase_titles = this.purchaseTitlesControl.value;
      this.facility!.latitude = this.facilityLatControl.value;
      this.facility!.longitude = this.facilityLngControl.value;
      this.facility!.map_zoom_top = this.mapZoomTopControl.value;
      this.facility!.map_zoom_map = this.mapZoomMapControl.value;
      this.facility!.addresses = this.addressesControl.value;
      this.facility!.policies = this.policiesControl.value;
      this.facility!.copyrights = this.copyrightsControl.value;
      this.facility!.faqs = this.faqsControl.value;
      this.facility!.theme_color = this.themeColorControl.value;
      this.facility!.meta_keywords = this.metaKeywordsControl.value;
      this.facility!.meta_description = this.metaDescriptionControl.value;
      this.facility!.google_analytics_code = this.googleAnalyticsCodeControl.value;
      this.facility!.site_url = this.siteUrlControl.value;
      this.facility!.site_url_staging = this.siteUrlStagingControl.value;
      this.facility!.telephone_number = this.telephoneNumberControl.value;
      this.facility!.map_disp_type = this.mapDispTypeControl.value;
      this.facility!.visible_good = this.visibleGoodControl.value;
      this.facility!.unvisible_breadcrumb = this.unVisibleBreadcrumbControl.value;
      this.facility!.unvisible_guide_number = this.unVisibleGuideNumberControl.value;
      this.facility!.unvisible_floor_name = this.unvisibleFloorNameControl.value;
      this.facility!.unvisible_reservation_facility_name = this.unvisibleReservationFacilityNameControl.value;
      this.facility!.use_guide = this.useGuideControl.value;
      this.facility!.unvisible_enter_num = undefined;
      this.facility!.use_number_entry = this.useNumberEntryControl.value;
      this.facility!.use_enter_num_title = this.useEnterNumTitleControl.value;
      this.facility!.enter_num_titles = this.enterNumTitlesControl.value;
      this.facility!.enter_num_helps = this.enterNumHelpsControl.value;
      this.facility!.visible_enquete = undefined;
      this.facility!.use_question = this.useQuestionControl.value;
      this.facility!.visible_enquete_thanks = this.visibleEnqueteThanksControl.value;
      this.facility!.use_enquete_thanks_title = this.useEnqueteThanksTitleControl.value;
      this.facility!.enquete_thanks_titles = this.enqueteThanksTitlesControl.value;
      this.facility!.visible_ranking = undefined;
      this.facility!.use_ranking = this.useRankingControl.value;
      this.facility!.visible_shelter = undefined;
      this.facility!.use_shelter = this.useShelterControl.value;
      this.facility!.visible_paid_content = undefined;
      this.facility!.use_paid_content = this.usePaidContentControl.value;
      this.facility!.visible_all_map = undefined;
      this.facility!.use_all_map = this.useAllMapControl.value;
      this.facility!.use_entry_form = this.useEntryFormControl.value;
      this.facility!.not_overlap_guide = this.notOverlapGuideControl.value;
      this.facility!.top_text_align_left = this.topTextAlignLeftControl.value;
      this.facility!.floor_text_align_left = this.floorTextAlignLeftControl.value;
      this.facility!.exhibit_text_align_left = this.exhibitTextAlignLeftControl.value;
      this.facility!.facility_file_link = this.facilityFileLinkControl.value;
      this.facility!.menu_style = this.menuStyleControl.value;
      this.facility!.language_icon_type = this.languageIconTypeControl.value;
      this.facility!.voice_control_type = this.voiceControlTypeControl.value;
      this.facility!.pin_tap_voice_control_type = this.pinTapVoiceControlTypeControl.value;
      if (this.facility) {
        if (this.data.change_type === AppConst.DATA_CHANGE_TYPE_ADD) {
          this.facility!.project_id = this.projectId;
        }
        let request: ApiSetFacilitiesRequest = {
          access_token: '',
          change_type: this.data.change_type,
          facilities: [this.facility]
        }
        this.spinnerService.openSpinner();
        this.apiClientService.setFacilities(request).then(
          response => {
            if (response!.ret === AppConst.API_RET_SUCCESS) {
              this.translate.get('登録しました。').subscribe((res: string) => {
                this.toastr.success(res);
              });
              this.dialogRef.close();
            } else if (response!.ret === AppConst.API_RET_ALREADY_EXIST_DATA) {
              this.toastr.error(this.translate.instant('既に同じIDが登録済みです。'), '', { timeOut : 5000 });
            } else {
              console.error('api update error. ret='+response!.ret);
              this.toastr.error(this.translate.instant('登録できませんでした。'), '', { timeOut : 5000 });
            }
          }
        ).catch(
          error => {
            console.log(error);
            this.toastr.error(this.translate.instant('登録できませんでした。'), '', { timeOut : 5000 });
          }
        ).finally(
          () => {
            this.spinnerService.closeSpinner();
          }
        );
      }
    }
  }

  //施設名称ダイアログ
  openFacilityNameDialog(): void {
    const dialogRef = this.dialog.open(MultiNameDialogComponent, {
      width: '60%',
      height: '90%',
      disableClose: true,
      data: { names: this.facility!.facility_names }
    });

    dialogRef.afterClosed().subscribe(result => {
      if (!!result) {
        this.facility!.facility_names = result;
        this.facilityNamesControl.setValue(this.facility!.facility_names);
      }
    });
  }

  //施設詳細ダイアログ
  openFacilityDescDialog(): void {
    const dialogRef = this.dialog.open(MultiDescDialogComponent, {
      width: '60%',
      height: '90%',
      disableClose: true,
      data: { descs: this.facility!.facility_descs }
    });

    dialogRef.afterClosed().subscribe(result => {
      if (!!result) {
        this.facility!.facility_descs = result;
        this.facilityDescsControl.setValue(this.facility!.facility_descs);
      }
    });
  }

  //住所ダイアログ
  openAddressDialog(): void {
    const dialogRef = this.dialog.open(MultiAddressDialogComponent, {
      width: '60%',
      height: '90%',
      disableClose: true,
      data: { addresses: this.facility!.addresses }
    });

    dialogRef.afterClosed().subscribe(result => {
      if (!!result) {
        this.facility!.addresses = result;
        this.addressesControl.setValue(this.facility!.addresses);
      }
    });
  }

  //プライバシーポリシーダイアログ
  openPolicyDialog(): void {
    const dialogRef = this.dialog.open(MultiPolicyDialogComponent, {
      width: '60%',
      height: '90%',
      disableClose: true,
      data: { policies: this.facility!.policies }
    });

    dialogRef.afterClosed().subscribe(result => {
      if (!!result) {
        this.facility!.policies = result;
        this.policiesControl.setValue(this.facility!.policies);
      }
    });
  }

  //コピーライトダイアログ
  openCopyrightDialog(): void {
    const dialogRef = this.dialog.open(MultiCopyrightDialogComponent, {
      width: '60%',
      height: '90%',
      disableClose: true,
      data: { copyrights: this.facility!.copyrights }
    });

    dialogRef.afterClosed().subscribe(result => {
      if (!!result) {
        this.facility!.copyrights = result;
        this.copyrightsControl.setValue(this.facility!.copyrights);
      }
    });
  }

  //FAQダイアログ
  openFaqDialog(): void {
    const dialogRef = this.dialog.open(MultiFaqDialogComponent, {
      width: '60%',
      height: '90%',
      disableClose: true,
      data: { faqs: this.facility!.faqs }
    });

    dialogRef.afterClosed().subscribe(result => {
      if (!!result) {
        this.facility!.faqs = result;
        this.faqsControl.setValue(this.facility!.faqs);
      }
    });
  }

  //faviconファイル選択ダイアログ
  openSelectFaviconFileDialog(): void {
    const dialogRef = this.dialog.open(SelectFaviconFileDialogComponent, {
      width: '80%',
      height: '90%',
      disableClose: true,
      data: { uploadedFile: null }
    });

    dialogRef.afterClosed().subscribe(result => {
      let isChanged: boolean = false;
      if (!!result) {
        this.facility!.favicon_file = result.id;
        isChanged = true;
      }
      if (!!isChanged) {
        this.getFaviconFile();
      }
    });
  }

  deleteFaviconFile(): void {
    if (!!this.facility!.favicon_file) {
      this.facility!.favicon_file = undefined;
      this.getFaviconFile();
    }
  }

  //ロゴ画像ファイル選択ダイアログ
  openSelectLogoFileDialog(): void {
    const dialogRef = this.dialog.open(SelectUploadedFileDialogComponent, {
      width: '80%',
      height: '90%',
      disableClose: true,
      data: { uploadedFile: null }
    });

    dialogRef.afterClosed().subscribe(result => {
      if (!!result && result.length > 0) {
        for (const row of result) {
          const lang = this.projectLanguages[0].lang_code;
          this.facility!.logo_files!.push({ file_id: row.id, lang_code: lang });
        }
        this.getLogoFiles();
      }
    });
  }

  deleteLogoFiles(i: number): void {
    this.facility!.logo_files!.splice(i, 1);
    this.getLogoFiles();
  }

  //施設画像ファイル選択ダイアログ
  openSelectFilesDialog(): void {
    const dialogRef = this.dialog.open(SelectUploadedFileDialogComponent, {
      width: '90%',
      disableClose: true,
      data: { uploadedFile: null }
    });

    dialogRef.afterClosed().subscribe(result => {
      if (!!result && result.length > 0) {
        for (const row of result) {
          const lang = this.projectLanguages[0].lang_code;
          this.facility!.facility_files!.push({ file_id: row.id, lang_code: lang });
        }
        this.getFiles();
      }
    });
  }

  deleteFiles(i: number): void {
    this.facility!.facility_files!.splice(i, 1);
    this.getFiles();
  }

  //Youtube埋め込みコードダイアログ
  openYoutubeCodeDialog(): void {
    const dialogRef = this.dialog.open(MultiYoutubeDialogComponent, {
      width: '60%',
      disableClose: true,
      data: { codes: this.facility!.youtube_codes }
    });

    dialogRef.afterClosed().subscribe(result => {
      if (!!result) {
        this.facility!.youtube_codes = result;
        this.youtubeCodesControl.setValue(this.facility!.youtube_codes);
      }
    });
  }

  //外部リンク名称ダイアログ
  openExternallinkNameDialog(): void {
    const dialogRef = this.dialog.open(MultiNameDialogComponent, {
      width: '60%',
      height: '90%',
      disableClose: true,
      data: { names: this.facility!.externallink_names }
    });

    dialogRef.afterClosed().subscribe(result => {
      if (!!result) {
        this.facility!.externallink_names = result;
        this.externallinkNamesControl.setValue(this.facility!.externallink_names);
      }
    });
  }

  //外部リンクＵＲＬダイアログ
  openExternallinkUrlDialog(): void {
    const dialogRef = this.dialog.open(MultiExternallinkDialogComponent, {
      width: '60%',
      height: '90%',
      disableClose: true,
      data: { codes: this.facility!.externallink_urls }
    });

    dialogRef.afterClosed().subscribe(result => {
      if (!!result) {
        this.facility!.externallink_urls = result;
        this.externallinkUrlsControl.setValue(this.facility!.externallink_urls);
      }
    });
  }

  //番号入力ダイアログ
  openEnterNumTitleDialog(): void {
    const dialogRef = this.dialog.open(MultiNameDialogComponent, {
      width: '60%',
      height: '90%',
      disableClose: true,
      data: { names: this.facility!.enter_num_titles }
    });

    dialogRef.afterClosed().subscribe(result => {
      if (!!result) {
        this.facility!.enter_num_titles = result;
        this.enterNumTitlesControl.setValue(this.facility!.enter_num_titles);
      }
    });
  }

  //番号入力説明ダイアログ
  openEnterNumHelpDialog(): void {
    const dialogRef = this.dialog.open(MultiNameDialogComponent, {
      width: '60%',
      height: '90%',
      disableClose: true,
      data: { names: this.facility!.enter_num_helps }
    });

    dialogRef.afterClosed().subscribe(result => {
      if (!!result) {
        this.facility!.enter_num_helps = result;
        this.enterNumHelpsControl.setValue(this.facility!.enter_num_helps);
      }
    });
  }
  
  //購入ダイアログ
  openPurchaseTitleDialog(): void {
    const dialogRef = this.dialog.open(MultiNameDialogComponent, {
      width: '60%',
      height: '90%',
      disableClose: true,
      data: { names: this.facility!.purchase_titles }
    });

    dialogRef.afterClosed().subscribe(result => {
      if (!!result) {
        this.facility!.purchase_titles = result;
        this.purchaseTitlesControl.setValue(this.facility!.purchase_titles);
      }
    });
  }

  //アンケートへのご回答ありがとうございましたダイアログ
  openEnqueteThanksTitleDialog(): void {
    const dialogRef = this.dialog.open(MultiTextMessageDialogComponent, {
      width: '60%',
      height: '90%',
      disableClose: true,
      data: {
        title: this.translate.instant('アンケート回答後メッセージ'),
        text_messages: this.facility!.enquete_thanks_titles
      }
    });

    dialogRef.afterClosed().subscribe(result => {
      if (!!result) {
        this.facility!.enquete_thanks_titles = result;
        this.enqueteThanksTitlesControl.setValue(this.facility!.enquete_thanks_titles);
      }
    });
  }

  //フロア選択ダイアログ
  openSelectFloorsDialog(): void {
    const dialogRef = this.dialog.open(SelectFloorsDialogComponent, {
      width: '80%',
      disableClose: true,
      data: { floor: null }
    });

    dialogRef.afterClosed().subscribe(result => {
      if (!!result && result.length > 0) {
        if (!this.facility!.floor_ids) {
          this.facility!.floor_ids = new Array<string>();
        }
        let isChanged: boolean = false;
        for (const row of result) {
          if (!this.facility!.floor_ids.includes(row.id)) {
            this.facility!.floor_ids.push(row.id);
            isChanged = true;
          }
        }
        if (!!isChanged) {
          this.getFloors();
        }
      }
    });
  }

  //フロアリストの削除
  deleteFloor(id: string): void {
    if (!!this.facility!.floor_ids!.includes(id)) {
      this.facility!.floor_ids = this.facility!.floor_ids!.filter(value => value !== id);
      this.getFloors();
    }
  }

  onNoClick(): void {
    this.dialogRef.close();
  }

  // マップ検索用のキー制御
  onKeyDownFromSearchPlace(keyCode: number): boolean {
    if (keyCode && keyCode === 13) {
      // NOTE: Enterを叩かれると他の項目の編集ボタンが反応してしまうのを防ぐ
      return false;
    }
    return true;
  }

  // マップ検索
  searchMap(): void {
    const places = this.searchBox.getPlaces();
    if (places!.length === 0) {
      return;
    }
    const bounds = new google.maps.LatLngBounds();
    places!.forEach(place => {
      if (!place.geometry || !place.geometry.location) {
        return;
      }
      if (place.geometry.viewport) {
        bounds.union(place.geometry.viewport);
      } else {
        bounds.extend(place.geometry.location);
      }
    });
    // console.log(bounds.getCenter().lat());
    // this.map.fitBounds(bounds);
    this.facilityLatControl.setValue(this.round(bounds.getCenter().lat(), 8));
    this.facilityLngControl.setValue(this.round(bounds.getCenter().lng(), 8));
    this.currentPosition = {
      lat: this.round(bounds.getCenter().lat(), 8),
      lng: this.round(bounds.getCenter().lng(), 8)
    }
    this.map.panTo(this.currentPosition);
  }

  // マップ検索フィールドクリア
  clearMapSearchField(): void {
    this.searchField.nativeElement.value = "";
  }

  // キーボックス追加
  appendKeyDevice(): void {
    if (!this.facility!.splats_key_devices) {
      this.facility!.splats_key_devices = new Array();
    }
    this.facility!.splats_key_devices!.push({
      id: '',
      name: '',
      api_type: 0,
      units: [],
    });
  }
  
  // キーボックス並べ替え
  onDropKeyDevice(event: CdkDragDrop<string[]>) {
    moveItemInArray(this.facility!.splats_key_devices, event.previousIndex, event.currentIndex);
    let keyDevices: Array<ApiSplatsKeyDevice> = [];
    for (const keyDevice of this.facility!.splats_key_devices) {
      keyDevices.push({id: keyDevice.id, name: keyDevice.name, api_type: keyDevice.api_type, units: keyDevice.units});
    }
    this.facility!.splats_key_devices = keyDevices;
  }

  // キーボックス削除
  deleteKeyDevice(index: number): void {
    this.facility!.splats_key_devices!.splice(index, 1);
  }

  // キーボックス環境設定
  changeKeyDeviceApiType(event: any, index: number): void {
    this.facility!.splats_key_devices![index].api_type = event.value;
    this.facility!.splats_key_devices![index].id = '';
    this.facility!.splats_key_devices![index].name = '';
    this.facility!.splats_key_devices![index].units = [];
  }

  // キーボックスID設定
  changeKeyDeviceId(event: any, index: number): void {
    this.facility!.splats_key_devices![index].id = event.value;
    if (this.facility!.splats_key_devices![index].api_type === AppConst.SPLATS_API_TYPE_SHARE) {
      for (const shareKeyDevice of this.shareKeyDevices) {
        if (shareKeyDevice.id === this.facility!.splats_key_devices![index].id) {
          this.facility!.splats_key_devices![index].name = shareKeyDevice.name;
          this.facility!.splats_key_devices![index].units = shareKeyDevice.units;
          return;
        }
      }
    } else if (this.facility!.splats_key_devices![index].api_type === AppConst.SPLATS_API_TYPE_PRODUCTION) {
      for (const productionKeyDevice of this.productionKeyDevices) {
        if (productionKeyDevice.id === this.facility!.splats_key_devices![index].id) {
          this.facility!.splats_key_devices![index].name = productionKeyDevice.name;
          this.facility!.splats_key_devices![index].units = productionKeyDevice.units;
          return;
        }
      }
    }
  }
  
  // SPLATSキーボックスを正しく入力しているか
  isValidSplatsKeyDevices(): boolean {
    if (!!this.facility!.splats_key_devices) {
      for (const keyDevice of this.facility!.splats_key_devices) {
        if (!keyDevice.api_type || !keyDevice.id || !keyDevice.name || !keyDevice.units) {
          return false;
        }
      }
    }
    return true;
  }

}
